const NAVIGATION_HEIGHT = "64px";
const APP_SIDEBAR_WIDTH = "132px";

export { NAVIGATION_HEIGHT, APP_SIDEBAR_WIDTH };
